import StatelessPageName from './StatelessPageName';

export default StatelessPageName;
